const settingsConfig = {
  layout: {
    style: 'layoutMain', // layout-1 layout-2 layout-3
    config: {}, // checkout layout configs at app/fuse-configs/layout-1/Layout1Config.js
  },
  customScrollbars: true,
  direction: 'ltr',
  theme: {
    main: 'default',
    navbar: 'default',
    toolbar: 'default',
    footer: 'default',
  },
}

export default settingsConfig
